import {
  CHECKOUT_PAGE,
} from "../Constants/AppConstants";

// Category list
export const setCheckoutPage = (payload) => async (dispatch) => {
  
  
  dispatch({ type: CHECKOUT_PAGE, payload: payload });
};
